import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {toastr} from "react-redux-toastr";
import { API_EXCEPTIONS } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { PaginationProps } from "../../../common/types/PaginationProps";

interface IGetExceptionsResponse {
    totalItems: 0,
    pageNum: 0,
    pageSize: 0,
    message: "string",
    isOK: true,
    sort: 0,
    sortField: string,
    search: string,
    items: ILoggingItem[],
    totalPages: number
}

interface ILoggingExceptionsState {
    exceptions: ILoggingItem[]
    stackTrace: IStackTrace | null
    pagination: PaginationProps
}

export interface ILoggingItem {
    id: number,
    type: string,
    message: string,
    source: string,
    date: string
}

export interface IStackTrace {
    id: 0,
    type: string,
    message: string,
    source: string,
    date: string,
    stackTrace: string
}

const initialState: ILoggingExceptionsState = {
    pagination: {
        activePage: 1,
        pageSize: 10,
        totalPages: 1,
    },
    exceptions: [],
    stackTrace: null
}

export const getExceptions = createAsyncThunk<IGetExceptionsResponse, string, { rejectValue: string }>(
    'logging/get-exceptions',
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_EXCEPTIONS}/?${query}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const getStackTrace = createAsyncThunk<IStackTrace, string | number, { rejectValue: string }>(
    'logging/get-stacktrace',
    async (id, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_EXCEPTIONS}/${id}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const deleteException = createAsyncThunk<{ id: number | string }, string | number, { rejectValue: string }>(
    'logging/delete-exception',
    async (id, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_EXCEPTIONS}/${id}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)


export const LoggingExceptionsSlice = createSlice({
    name: 'loggingException',
    reducers: {
        setPageNum: (state, action) => {
            state.pagination.activePage = action.payload
        },
        clearStackTrace: (state) => {
            state.stackTrace = null
        },
        changePageSize: (state, action) => {
            state.pagination.pageSize = action.payload
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getExceptions.pending, (state: ILoggingExceptionsState) => {

            })
            .addCase(getExceptions.fulfilled, (state: ILoggingExceptionsState, action) => {
                state.exceptions = action.payload.items
                state.pagination.totalPages = action.payload.totalPages
            })
            .addCase(getStackTrace.fulfilled, (state: ILoggingExceptionsState, action) => {
                state.stackTrace = action.payload
            })
            .addCase(deleteException.fulfilled, (state: ILoggingExceptionsState, action) => {
                state.exceptions = state.exceptions.filter(exc => exc.id !== action.payload.id)
            })

    }
})
export const { setPageNum, clearStackTrace, changePageSize } = LoggingExceptionsSlice.actions
export default LoggingExceptionsSlice.reducer;



